import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const StarBurstHalf: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg width="227" height="231" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g stroke="#FFCD85" strokeMiterlimit="10">
        <path
          d="m67.719 90.494 48.644-21.849M116.053 147.087l30.97-42.687M186.967 172.556l1.831-19.44M54.922 17.963l19.474 1.74M56.455 55.026l42.183-7.052M88.063 121.865l43.628-35.343M164.683 124.995 149.8 164.338"
          strokeWidth="4"
        />
        <path
          d="M116.361 68.644 172.53 43.46M147.02 104.399l35.665-49.096M188.795 153.116l7.72-81.686M74.394 19.704l84.211 7.516M63.324-18.261l81.355 29.242M98.633 47.972l68.018-11.367M131.69 86.522l45.917-37.141M164.682 124.995l23.848-62.877M225.057 171.104l-14.746-83.585"
          strokeOpacity=".5"
          strokeWidth="1.5"
        />
        <path
          d="M253.429-42.289 218.088 6.354M268.759-24.412l-45.496 36.8M235.769-62.884 212.118-.61"
          strokeOpacity=".75"
          strokeWidth="1.5"
        />
        <path
          d="m200.321 30.979-27.791 12.48M182.686 55.302l17.635-24.324M196.517 71.431l3.806-40.451M247.776 131.209l-47.454-100.23M200.321 30.978l94.898 65.324M200.321 30.98l42.105 3.758M200.321 30.979l28.085-12.593M200.32 30.979l17.833-24.548M200.32 30.979l3.844-40.861M152.393-70.256 200.32 30.979M106.355-33.712l93.966 64.69M200.321 30.979l-41.716-3.759M200.321 30.979 144.68 10.982M200.321 30.979l-33.667 5.627M200.321 30.979 177.608 49.38M188.532 62.12l11.791-31.14M210.312 87.52l-9.991-56.54M200.322 30.98l56.189 20.182M200.32 30.979l33.993-5.703M200.323 30.98l22.942-18.59M200.32 30.979 212.244-.46M190.239-26.121l10.081 57.1"
          strokeOpacity=".15"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
};

export { StarBurstHalf };
